/* Vecno — deals/clearance strip.
   Rolls each percentage once when the strip first comes into view. The markup
   already shows the right number, so nothing is wrong before this runs. */
(function () {
  var S = document.getElementById('vst');
  if (!S || S.dataset.on) return;
  S.dataset.on = '1';

  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* each half starts its roll a beat after the one before it */
  Array.prototype.forEach.call(S.querySelectorAll('[data-half]'), function (half, h) {
    var digits = half.querySelectorAll('.vst__d');
    Array.prototype.forEach.call(digits, function (d, i) {
      var to = parseInt(d.dataset.v, 10);
      if (isNaN(to)) to = 0;
      d.style.setProperty('--to', to);
      d.style.setProperty('--from', (to + 5) % 10);
      d.style.setProperty('--i', i);
      d.style.setProperty('--base', (h * 0.18) + 's');
    });
  });

  function run() { S.classList.add('is-on'); }

  if (reduce || !('IntersectionObserver' in window)) { run(); return; }

  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { run(); io.disconnect(); }
    });
  }, { threshold: 0.4 });
  io.observe(S);
})();
